//
// Copyright 2021 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/devtools/host.proto (package dxos.devtools.host, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { FeedMessage } from "../echo/feed_pb.js";
import { file_dxos_echo_feed } from "../echo/feed_pb.js";
import type { EchoMetadata } from "../echo/metadata_pb.js";
import { file_dxos_echo_metadata } from "../echo/metadata_pb.js";
import type { SpaceSnapshot } from "../echo/snapshot_pb.js";
import { file_dxos_echo_snapshot } from "../echo/snapshot_pb.js";
import type { TimeframeVector } from "../echo/timeframe_pb.js";
import { file_dxos_echo_timeframe } from "../echo/timeframe_pb.js";
import type { PublicKey } from "../keys_pb.js";
import { file_dxos_keys } from "../keys_pb.js";
import type { Message as Message$1, SwarmEvent } from "../mesh/signal_pb.js";
import { file_dxos_mesh_signal } from "../mesh/signal_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/devtools/host.proto.
 */
export const file_dxos_devtools_host: GenFile = /*@__PURE__*/
  fileDesc("ChhkeG9zL2RldnRvb2xzL2hvc3QucHJvdG8SEmR4b3MuZGV2dG9vbHMuaG9zdCJRChtTdWJzY3JpYmVUb01ldGFkYXRhUmVzcG9uc2USMgoIbWV0YWRhdGEYASABKAsyIC5keG9zLmVjaG8ubWV0YWRhdGEuRWNob01ldGFkYXRhIvMCChlTdWJzY3JpYmVUb1NwYWNlc1Jlc3BvbnNlEkcKBnNwYWNlcxgBIAMoCzI3LmR4b3MuZGV2dG9vbHMuaG9zdC5TdWJzY3JpYmVUb1NwYWNlc1Jlc3BvbnNlLlNwYWNlSW5mbxqMAgoJU3BhY2VJbmZvEiEKA2tleRgBIAEoCzIULmR4b3Mua2V5cy5QdWJsaWNLZXkSDwoHaXNfb3BlbhgCIAEoCBI8Cgl0aW1lZnJhbWUYAyABKAsyJC5keG9zLmVjaG8udGltZWZyYW1lLlRpbWVmcmFtZVZlY3RvckgAiAEBEioKDGdlbmVzaXNfZmVlZBgEIAEoCzIULmR4b3Mua2V5cy5QdWJsaWNLZXkSKgoMY29udHJvbF9mZWVkGAUgASgLMhQuZHhvcy5rZXlzLlB1YmxpY0tleRInCglkYXRhX2ZlZWQYBiABKAsyFC5keG9zLmtleXMuUHVibGljS2V5QgwKCl90aW1lZnJhbWUi0QEKHVN1YnNjcmliZVRvRmVlZEJsb2Nrc1Jlc3BvbnNlEkcKBmJsb2NrcxgBIAMoCzI3LmR4b3MuZGV2dG9vbHMuaG9zdC5TdWJzY3JpYmVUb0ZlZWRCbG9ja3NSZXNwb25zZS5CbG9jaxpnCgVCbG9jaxImCghmZWVkX2tleRgBIAEoCzIULmR4b3Mua2V5cy5QdWJsaWNLZXkSCwoDc2VxGAIgASgFEikKBGRhdGEYAyABKAsyGy5keG9zLmVjaG8uZmVlZC5GZWVkTWVzc2FnZSJhChhHZXRTcGFjZVNuYXBzaG90UmVzcG9uc2USOAoIc25hcHNob3QYASABKAsyIS5keG9zLmVjaG8uc25hcHNob3QuU3BhY2VTbmFwc2hvdEgAiAEBQgsKCV9zbmFwc2hvdCJiChlTYXZlU3BhY2VTbmFwc2hvdFJlc3BvbnNlEjgKCHNuYXBzaG90GAEgASgLMiEuZHhvcy5lY2hvLnNuYXBzaG90LlNwYWNlU25hcHNob3RIAIgBAUILCglfc25hcHNob3QiygEKDlNpZ25hbFJlc3BvbnNlEjMKC3N3YXJtX2V2ZW50GAEgASgLMhwuZHhvcy5tZXNoLnNpZ25hbC5Td2FybUV2ZW50SAASLAoHbWVzc2FnZRgCIAEoCzIZLmR4b3MubWVzaC5zaWduYWwuTWVzc2FnZUgAEi8KC3JlY2VpdmVkX2F0GAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBISCgV0b3BpYxgEIAEoDEgBiAEBQgYKBGRhdGFCCAoGX3RvcGljYgZwcm90bzM", [file_google_protobuf_timestamp, file_dxos_echo_feed, file_dxos_echo_metadata, file_dxos_echo_snapshot, file_dxos_echo_timeframe, file_dxos_keys, file_dxos_mesh_signal]);

/**
 * @generated from message dxos.devtools.host.SubscribeToMetadataResponse
 */
export type SubscribeToMetadataResponse = Message<"dxos.devtools.host.SubscribeToMetadataResponse"> & {
  /**
   * @generated from field: dxos.echo.metadata.EchoMetadata metadata = 1;
   */
  metadata?: EchoMetadata;
};

/**
 * Describes the message dxos.devtools.host.SubscribeToMetadataResponse.
 * Use `create(SubscribeToMetadataResponseSchema)` to create a new message.
 */
export const SubscribeToMetadataResponseSchema: GenMessage<SubscribeToMetadataResponse> = /*@__PURE__*/
  messageDesc(file_dxos_devtools_host, 0);

/**
 * @generated from message dxos.devtools.host.SubscribeToSpacesResponse
 */
export type SubscribeToSpacesResponse = Message<"dxos.devtools.host.SubscribeToSpacesResponse"> & {
  /**
   * @generated from field: repeated dxos.devtools.host.SubscribeToSpacesResponse.SpaceInfo spaces = 1;
   */
  spaces: SubscribeToSpacesResponse_SpaceInfo[];
};

/**
 * Describes the message dxos.devtools.host.SubscribeToSpacesResponse.
 * Use `create(SubscribeToSpacesResponseSchema)` to create a new message.
 */
export const SubscribeToSpacesResponseSchema: GenMessage<SubscribeToSpacesResponse> = /*@__PURE__*/
  messageDesc(file_dxos_devtools_host, 1);

/**
 * @generated from message dxos.devtools.host.SubscribeToSpacesResponse.SpaceInfo
 */
export type SubscribeToSpacesResponse_SpaceInfo = Message<"dxos.devtools.host.SubscribeToSpacesResponse.SpaceInfo"> & {
  /**
   * @generated from field: dxos.keys.PublicKey key = 1;
   */
  key?: PublicKey;

  /**
   * @generated from field: bool is_open = 2;
   */
  isOpen: boolean;

  /**
   * @generated from field: optional dxos.echo.timeframe.TimeframeVector timeframe = 3;
   */
  timeframe?: TimeframeVector;

  /**
   * @generated from field: dxos.keys.PublicKey genesis_feed = 4;
   */
  genesisFeed?: PublicKey;

  /**
   * @generated from field: dxos.keys.PublicKey control_feed = 5;
   */
  controlFeed?: PublicKey;

  /**
   * @generated from field: dxos.keys.PublicKey data_feed = 6;
   */
  dataFeed?: PublicKey;
};

/**
 * Describes the message dxos.devtools.host.SubscribeToSpacesResponse.SpaceInfo.
 * Use `create(SubscribeToSpacesResponse_SpaceInfoSchema)` to create a new message.
 */
export const SubscribeToSpacesResponse_SpaceInfoSchema: GenMessage<SubscribeToSpacesResponse_SpaceInfo> = /*@__PURE__*/
  messageDesc(file_dxos_devtools_host, 1, 0);

/**
 * @generated from message dxos.devtools.host.SubscribeToFeedBlocksResponse
 */
export type SubscribeToFeedBlocksResponse = Message<"dxos.devtools.host.SubscribeToFeedBlocksResponse"> & {
  /**
   * @generated from field: repeated dxos.devtools.host.SubscribeToFeedBlocksResponse.Block blocks = 1;
   */
  blocks: SubscribeToFeedBlocksResponse_Block[];
};

/**
 * Describes the message dxos.devtools.host.SubscribeToFeedBlocksResponse.
 * Use `create(SubscribeToFeedBlocksResponseSchema)` to create a new message.
 */
export const SubscribeToFeedBlocksResponseSchema: GenMessage<SubscribeToFeedBlocksResponse> = /*@__PURE__*/
  messageDesc(file_dxos_devtools_host, 2);

/**
 * @generated from message dxos.devtools.host.SubscribeToFeedBlocksResponse.Block
 */
export type SubscribeToFeedBlocksResponse_Block = Message<"dxos.devtools.host.SubscribeToFeedBlocksResponse.Block"> & {
  /**
   * @generated from field: dxos.keys.PublicKey feed_key = 1;
   */
  feedKey?: PublicKey;

  /**
   * @generated from field: int32 seq = 2;
   */
  seq: number;

  /**
   * @generated from field: dxos.echo.feed.FeedMessage data = 3;
   */
  data?: FeedMessage;
};

/**
 * Describes the message dxos.devtools.host.SubscribeToFeedBlocksResponse.Block.
 * Use `create(SubscribeToFeedBlocksResponse_BlockSchema)` to create a new message.
 */
export const SubscribeToFeedBlocksResponse_BlockSchema: GenMessage<SubscribeToFeedBlocksResponse_Block> = /*@__PURE__*/
  messageDesc(file_dxos_devtools_host, 2, 0);

/**
 * @generated from message dxos.devtools.host.GetSpaceSnapshotResponse
 */
export type GetSpaceSnapshotResponse = Message<"dxos.devtools.host.GetSpaceSnapshotResponse"> & {
  /**
   * @generated from field: optional dxos.echo.snapshot.SpaceSnapshot snapshot = 1;
   */
  snapshot?: SpaceSnapshot;
};

/**
 * Describes the message dxos.devtools.host.GetSpaceSnapshotResponse.
 * Use `create(GetSpaceSnapshotResponseSchema)` to create a new message.
 */
export const GetSpaceSnapshotResponseSchema: GenMessage<GetSpaceSnapshotResponse> = /*@__PURE__*/
  messageDesc(file_dxos_devtools_host, 3);

/**
 * @generated from message dxos.devtools.host.SaveSpaceSnapshotResponse
 */
export type SaveSpaceSnapshotResponse = Message<"dxos.devtools.host.SaveSpaceSnapshotResponse"> & {
  /**
   * @generated from field: optional dxos.echo.snapshot.SpaceSnapshot snapshot = 1;
   */
  snapshot?: SpaceSnapshot;
};

/**
 * Describes the message dxos.devtools.host.SaveSpaceSnapshotResponse.
 * Use `create(SaveSpaceSnapshotResponseSchema)` to create a new message.
 */
export const SaveSpaceSnapshotResponseSchema: GenMessage<SaveSpaceSnapshotResponse> = /*@__PURE__*/
  messageDesc(file_dxos_devtools_host, 4);

/**
 * @generated from message dxos.devtools.host.SignalResponse
 */
export type SignalResponse = Message<"dxos.devtools.host.SignalResponse"> & {
  /**
   * @generated from oneof dxos.devtools.host.SignalResponse.data
   */
  data: {
    /**
     * @generated from field: dxos.mesh.signal.SwarmEvent swarm_event = 1;
     */
    value: SwarmEvent;
    case: "swarmEvent";
  } | {
    /**
     * @generated from field: dxos.mesh.signal.Message message = 2;
     */
    value: Message$1;
    case: "message";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: google.protobuf.Timestamp received_at = 3;
   */
  receivedAt?: Timestamp;

  /**
   * @generated from field: optional bytes topic = 4;
   */
  topic?: Uint8Array;
};

/**
 * Describes the message dxos.devtools.host.SignalResponse.
 * Use `create(SignalResponseSchema)` to create a new message.
 */
export const SignalResponseSchema: GenMessage<SignalResponse> = /*@__PURE__*/
  messageDesc(file_dxos_devtools_host, 5);

